import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import translate from '@/filters/Translate'

const app = createApp(App)
app.config.globalProperties.$filters = {
  translate
}
app
  .use(router)
  .mount('#app')
